<template>
    <div class="calendar">
        <div class="header">
            <el-row>
                <el-col>
                    <div class="page-title bold fnt-lg dark text-left">
                        Календарь доступности замерщиков
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row class="mb10">
                <el-col :span="1" class="text-center bold">
                    Дата:
                </el-col>
                <el-col :span="2">
                    <el-date-picker
                        v-model="startDay"
                        type="date"
                        placeholder="дд.мм.гггг"
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        @change="changeDate"
                        :clearable="false"
                        size="mini"
                        class="w100"
                    />
                </el-col>
                <el-col :span="2" class="text-center bold">
                    Показать дней:
                </el-col>
                <el-col :span="1">
                    <el-select
                        v-model="selectedDaysAmount"
                        size="mini"
                    >
                        <el-option
                            v-for="number in 7"
                            :key="number"
                            :label="number"
                            :value="number"
                        />
                    </el-select>
                </el-col>
                <el-col :span="2" class="text-center">
                    <el-button type="warning" @click="getCalendar">
                        выбрать
                    </el-button>
                </el-col>
                <el-col :span="1">
                    <el-button-group>
                        <el-button type="primary" icon="el-icon-arrow-left" @click="changeDateBackward" />
                        <el-button type="primary" icon="el-icon-arrow-right" @click="changeDateForward" />
                    </el-button-group>
                </el-col>
                <el-col :span="4" class="text-center bold calendar-top-filter-fired">
                    <span>Показывать уволенных</span>
                    <el-checkbox v-model="showFired" @change="getCalendar" />
                </el-col>
            </el-row>
            <el-row v-loading="loading">
                <el-col>
                    <div class="grid" :style="gridStyle">
                        <div class="grid-title">
                            Замерщик
                        </div>
                        <div
                            v-for="(statisticByDay, keyDay) in statistic"
                            :key="keyDay"
                            :class="[
                                'header-grid',
                                isWeekend(keyDay) ? 'weekend' : ''
                            ]"
                        >
                            <div class="header-grid-date">
                                <div class="header-grid-date-title">
                                    <span class="bold">
                                        {{ keyDay }}
                                    </span> ({{ getWeekDayName(keyDay) }})
                                </div>
                            </div>
                            <div
                                v-for="(statisticByTime, keyTime) in statisticByDay"
                                :key="keyTime"
                                class="header-grid-time"
                            >
                                <div class="bold">
                                    {{ keyTime }}
                                </div>
                                <div class="statistic-info">
                                    ({{ statisticByTime.occupied }}/{{ statisticByTime.total }})
                                </div>
                            </div>
                        </div>
                        <template v-for="measurer in measurers">
                            <div :key="measurer.id" :class="['measurer-title', isFiredEmployerClass(measurer.date_fired)]">
                                {{ measurer.full_name }}
                            </div>
                            <div
                                v-for="(measurerByDay, keyDay) in measurer.calendar"
                                :key="keyDay + measurer.id"
                                class="measurer-grid"
                            >
                                <template v-if="measurerByDay.timesheet.status_id !== localReferences.timesheet.statuses.working">
                                    <div
                                        class="measurer-grid-cell not-work"
                                        v-for="time in localReferences.measurementTimes.length"
                                        :key="time"
                                    >
                                        {{ measurerByDay.timesheet.status.short }}
                                    </div>
                                </template>
                                <template v-else>
                                    <template v-if="measurerByDay.deals.length">
                                        <div
                                            v-for="deal in measurerByDay.deals"
                                            :key="deal.id"
                                            :class="[
                                                'measurer-grid-cell column-deal clickable',
                                                deal.actual_measurement_time ? `column-deal-${deal.actual_measurement_time} time-${deal.actual_measurement_time}` : '',
                                                deal.actual_measurement_time && deal.difficult_metering ? `difficult-${deal.actual_measurement_time}` : ''
                                            ]"
                                        >
                                            <router-link :to="{ name: 'deal-card', params: { id: deal.id }}">
                                                {{ deal.id }}
                                            </router-link>
                                        </div>
                                    </template>
                                    <template>
                                        <div
                                            v-for="reservation in measurerByDay.reservations"
                                            :key="reservation.time"
                                            :class="[
                                                'measurer-grid-cell column-empty clickable',
                                                `time-${reservation.time}`,
                                                reservation.is_reserved ? 'reserved' : ''
                                            ]"
                                            :style="{ gridRow: measurerByDay.deals.length ? `span ${measurerByDay.deals.length}` : 'auto' }"
                                            @click="setReserve(reservation)"
                                        >
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </template>
                        <div class="unassigned-title">
                            Не назначено
                        </div>
                        <div
                            v-for="(unassignedPerDay, keyDay) in unassigned"
                            :key="'u' + keyDay"
                            class="unassigned-grid"
                        >
                            <div
                                v-for="deal in unassignedPerDay"
                                :key="deal.id"
                                :class="[
                                    'unassigned-grid-cell',
                                    'clickable',
                                    deal.actual_measurement_time ? `column-time-${deal.actual_measurement_time}` : '',
                                    deal.actual_measurement_time && deal.difficult_metering ? `difficult-${deal.actual_measurement_time}` : ''
                                ]"
                            >
                                <router-link :key="deal.id" :to="{ name: 'deal-card', params: { id: deal.id }}">
                                    {{ deal.id }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import '@/assets/styles/calendar.scss';
import moment from 'moment';
import { pickerOptions } from '@/common/pickerOptions';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'Calendar',
    data() {
        return {
            showFired: 0,
            loading: false,
            pickerOptions,
            localReferences,
            selectedDaysAmount: 7,
            columnsAmount: 7,
            startDay: moment().format('DD.MM.YYYY')
        };
    },
    computed: {
        gridStyle() {
            return {
                gridTemplateColumns: `158px repeat(${this.columnsAmount}, 200px)`,
                gridTemplateRows: `84px repeat(${this.measurers.length}, minmax(40px, max-content)) minmax(40px, 1fr)`,
                width: `${this.columnsAmount * 200 + 158}px`
            };
        },
        measurers() {
            return this.$store.state.calendar.measurers;
        },
        statistic() {
            return this.$store.state.calendar.statistic;
        },
        unassigned() {
            return this.$store.state.calendar.unassigned;
        },
        daysAmount() {
            return this.selectedDaysAmount - 1;
        }
    },
    methods: {
        getWeekDayName(day) {
            return moment(day, 'DD.MM.YYYY').locale('ru').format('ddd');
        },
        isWeekend(day) {
            return [6, 0].indexOf(moment(day, 'DD.MM.YYYY').weekday()) !== -1;
        },
        setReserve(reservation) {
            if (this.$store.getters.isCanEditCalendar) {
                this.processReservation(reservation);
            }
        },
        changeDate() {
            this.getCalendar();
        },
        changeDateBackward() {
            this.startDay = moment(this.startDay, 'DD.MM.YYYY').subtract(this.selectedDaysAmount, 'days').format('DD.MM.YYYY');
            this.getCalendar();
        },
        changeDateForward() {
            this.startDay = moment(this.startDay, 'DD.MM.YYYY').add(this.selectedDaysAmount, 'days').format('DD.MM.YYYY');
            this.getCalendar();
        },
        async getCalendar() {
            try {
                this.loading = true;
                await this.$store.dispatch('calendar/get', {
                    startDay: this.startDay,
                    endDay: moment(this.startDay, 'DD.MM.YYYY').add(this.daysAmount, 'days').format('DD.MM.YYYY'),
                    showFired: this.showFired
                });
                this.columnsAmount = this.selectedDaysAmount;
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        async processReservation(reservation) {
            try {
                this.loading = true;
                if (reservation.is_reserved) {
                    await this.$store.dispatch('calendar/deleteReservation', { reservation });
                } else {
                    await this.$store.dispatch('calendar/createReservation', { reservation });
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        isFiredEmployerClass(dateFired) {
            return dateFired ? 'fired_employer' : '';
        }
    },
    mounted() {
        this.getCalendar();
    }
};
</script>
